import listener from '@mailobj-browser/front/js/events/listeners/listener.js'
import passive from '@mailobj-browser/front/js/events/options/passive.js'
import closest from '@mailobj-browser/front/js/selectors/closest.js'
import * as utilities from '#utilities/js/styles.js'
import one from '@mailobj-browser/front/js/selectors/one.js'
import rendered from '@mailobj-browser/front/js/tree/rendered.js'
import object from '@mailobj-browser/front/js/utils/object.js'
import { modifiers, elements } from '../styles.js'
import { events } from '#components/generics/js/childHideable/container.js'
import { getHideables } from '#components/generics/js/childHideable/container.js'

const manageChildren = container => {
  requestAnimationFrame(async () => {
    const { hideableScopeJsons } = getHideables(container)
    const opener = one(`[data-contract~='actionsBar.dropdownOpener']`, container)
    const buttonsGroup = closest(`.${elements.buttons}`, opener)
    const { size } = hideableScopeJsons
    let index = 0
    let isSameButtonGroup = false

    for (const [element] of hideableScopeJsons) {
      index++

      if (!isSameButtonGroup) {
        const elementButtonsGroup = closest(`.${elements.buttons}`, element)

        if (elementButtonsGroup === buttonsGroup) {
          isSameButtonGroup = true
        }
      }

      if (isSameButtonGroup) {
        if (element.classList.contains(utilities.modifiers.display.none)) {
          opener.classList.remove(utilities.modifiers.display.none)

          break
        } else if (index === size) {
          opener.classList.add(utilities.modifiers.display.none)
        }
      } else {
        if (element.classList.contains(utilities.modifiers.display.none)) {
          buttonsGroup?.classList.remove(utilities.modifiers.display.none)

          break
        } else if (index === size) {
          buttonsGroup?.classList.add(utilities.modifiers.display.none)
          element.classList.add(modifiers.child_hideable.last_item)
        }
      }
    }

    onChildHideableReady.listen(container)
  })
}

const onChildHideableReady = object(listener, {
  type: events.ready,
  passive,
  task: container => {
    manageChildren(container)
  }
})

export default opener => {
  queueMicrotask(async () => {
    const { ownerDocument } = opener
    const { body } = ownerDocument

    await rendered(opener, body)

    const container = closest(`[data-contract~='childHideable.container']`, opener)

    manageChildren(container)
  })
}
